import React from "react";
import useNotifications from "../../hooks/useNotifications";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { toast } from "react-toastify";
import useMarketPlaceVerificationStatus from "../../hooks/useMarketPlaceVerificationStatus";

const Notifications = ({ onReadAll }) => {
  const { isVerified } = useMarketPlaceVerificationStatus();
  const token = localStorage.getItem("access_token");
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { notifications, setNotifications } = useNotifications();
  const navigate = useNavigate();

  const handleClick = (n) => {
    if (onReadAll) onReadAll();

    switch (n.message_identype) {
      case "message":
        navigate(`/chat?userId=${n.user_profile.id}`);
        break;

      case "connection_request":
        navigate(`/user-profile/${n.user_profile.id}`);
        break;

      case "collaborator_invitation":
        navigate(`/profile-view?tab=invitations`);
        break;

      case "interest_request":
        navigate(isVerified ? '/marketplace/independent_researcher/dashboard/interests' : '/marketplace')
        break;

      default:
        navigate(`/user-profile/${n.user_profile.id}`);
    }
  };

  const deleteNotification = async (notificationId) => {
    try {
      const response = await fetch(`${BASE_URL}/user/chat/notification/`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: JSON.stringify({ notification_id: notificationId }),
      });

      if (response.ok) {
        setNotifications((prev) =>
          prev.filter((notif) => notif.id !== notificationId)
        );
        toast.success("Notification deleted!");
      } else {
        const data = await response.json();
        toast.error(data?.detail || "Failed to delete notification");
      }
    } catch (err) {
      console.error("Failed to delete notification:", err);
      toast.error("Failed to delete notification.");
    }
  };

  return (
<div className="absolute top-12 right-0 w-96 max-h-[500px] min-h-[200px] overflow-y-auto bg-white rounded-2xl shadow-xl border border-gray-200 p-4 z-[1000]">
  <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-200">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
    </div>
    <h3 className="text-base font-semibold text-gray-900">
      Notifications
    </h3>
  </div>

  {notifications.length === 0 ? (
    <div className="flex flex-col items-center justify-center py-8">
      <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-3">
        <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
      </div>
      <p className="text-sm text-gray-500">
        No new notifications
      </p>
    </div>
  ) : (
    <ul className="space-y-2">
      {notifications?.map((n) => (
        <li
          key={n.id}
          onClick={() => handleClick(n)}
          className="group flex items-start gap-3 p-3 rounded-xl cursor-pointer transition-all hover:bg-gray-50"
        >
          <div className="flex-shrink-0">
            <img
              src={n.user_profile?.profile_picture}
              alt={n.user_profile?.name || "User"}
              className="w-10 h-10 rounded-full object-cover border border-gray-200"
            />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-sm text-gray-800">
              <strong className="font-semibold">{n.user_profile?.name}</strong> {n.message}
            </p>
            <span className="text-xs text-gray-500 mt-1 block">
              {n.timestamp}
            </span>
          </div>

          <button
            onClick={(e) => {
              e.stopPropagation();
              deleteNotification(n.id);
            }}
            className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 opacity-0 group-hover:opacity-100 hover:text-red-500 transition-all"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </li>
      ))}
    </ul>
  )}
</div>
  );
};

export default Notifications;
